module.exports = __webpack_public_path__ + "assets/img/mecha-e6290812.png";